/* global jQuery */

import { Module } from 'wrapper6'

export default class CheckoutHandler extends Module {
  ready () {
    this.CHECKOUT_FORM = jQuery('form[name="checkout"].woocommerce-checkout')
    if (this.CHECKOUT_FORM.length === 0) {
      return
    }

    this.handleOrderCommentsInput()
  }

  handleOrderCommentsInput () {
    const orderCommentsCharacterAmount = this.CHECKOUT_FORM.find('p.order-comments-character-amount .amount')

    this.CHECKOUT_FORM.on('input', 'textarea[name="order_comments"]', (e) => {
      const orderComments = jQuery(e.currentTarget)
      orderCommentsCharacterAmount.text(orderComments.val().length + ' / ' + orderComments.attr('maxlength'))
    })
  }
}
